import iconMixin from '../../mixins/iconMixin'

export default {
  mixins: [iconMixin],
  data: function () {
    return {
      viewBox: "0 0 24 24",
      rawSvgPath: '<path d="M13.5,4.75H13c-0.275,0-0.5,0.225-0.5,0.5v2.5c0,0.275,0.225,0.5,0.5,0.5h0.5c0.275,0,0.5-0.225,0.5-0.5v-2.5' +
        'C14,4.975,13.775,4.75,13.5,4.75z"/>' +
        '<path d="M20.293,6.293l-2.586-2.586C17.318,3.318,16.55,3,16,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V8' +
        'C21,7.45,20.682,6.682,20.293,6.293z M12,18.5c-1.933,0-3.5-1.566-3.5-3.5s1.567-3.5,3.5-3.5c1.934,0,3.5,1.566,3.5,3.5' +
        'S13.934,18.5,12,18.5z M15.5,8c0,0.55-0.45,1-1,1h-7c-0.55,0-1-0.45-1-1V5c0-0.55,0.45-1,1-1h7c0.55,0,1,0.45,1,1V8z"/>',
    }
  },
}